import { apiRequest } from '../actions/apiActions';
import { showLoading, hideLoading, addUiMsg, updateApiSpinner } from '../actions/uiActions';
import { GET_CURRENT_USER_INFO } from '../actions/currentUserActions';
import { apiUrls, apiVersion } from '../../apiUrls';
import { 
    GET_DOC_TREE,
    DOC_CATEGORY_ERROR,
    SUBMIT_CREATE_CATEGORY,
    SET_DOC_TREE,
    CREATE_CATEGORY_SUCCESS,
    CREATE_CATEGORY_ERROR,
    SUBMIT_FILE_REQUEST,
    CREATE_FILE_SUCCESS,
    CREATE_FILE_ERROR,
    FETCH_FILE_REQUEST,
    FETCH_FILE_SUCCESS,
    SET_FILE_DATA,
    SUBMIT_EDIT_CATEGORY,
    EDIT_CATEGORY_SUCCESS,
    EDIT_CATEGORY_ERROR,
    DELETE_CATEGORY_REQUEST,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_ERROR,
    SUBMIT_EDIT_FILE,
		EDIT_FILE_SUCCESS,
    EDIT_FILE_ERROR,
    DELETE_FILE_REQUEST,
    DELETE_FILE_SUCCESS,
    DELETE_FILE_ERROR,
    // ADD_UNCATEGORIZED_FILE,
    // ADD_UNCATEGORIZED_FILE_ERROR,
    // ADD_UNCATEGORIZED_FILE_SUCCESS,
    // ASSIGN_FILE_TO_CATEGORY,
    // ASSIGN_FILE_TO_CATEGORY_SUCCESS,
    // ASSIGN_FILE_TO_CATEGORY_ERROR,

} from '../actions/docCategoryAction';


import { errorDisplay } from '../../utilities/general';
import { messageTypes } from '../../components/ui/AlertMessage';


export const loadDocCategories = (store) => (next) => (action) => {
    next(action);
    if (action.type === GET_DOC_TREE) {
      const meta = {
        method: 'GET',
        url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages, 
        onSuccess: SET_DOC_TREE,
        onError: DOC_CATEGORY_ERROR,
        auth: store.getState().auth.token,
        body: false,
        setStateFunc: action.payload.setStateFunc,
      };
  
      store.dispatch(showLoading());
      store.dispatch(apiRequest(null, meta));
    }
  };

  export const setDocTree = ({ dispatch }) => (next) => (action) => {
    next(action);
    if (action.type === SET_DOC_TREE ) {
      dispatch(hideLoading());
      action.meta.setStateFunc(action.payload)
    }
  };

  export const submitCreateCategory = (store) => (next) => (action) => {
    next(action);

      const state = store.getState();
      
      // Check if we have user data, if not, fetch it first
      const hasUserData = state.currentUser || state.auth?.user || state.user;
      
      if (!hasUserData && state.auth?.token) {
        
        
        // Dispatch action to get current user info
        store.dispatch({ type: GET_CURRENT_USER_INFO });
      
      }
    if (action.type === SUBMIT_CREATE_CATEGORY) {
      // const defaultParentId = 'sara';
      // const currentUser = store.getState().auth.user;
      const currentUser = state.currentUser || state.auth?.user || state.user;
      let createdBy = 'System User'; // Default fallback

      if (currentUser && (currentUser.name || currentUser.username)) {
        createdBy = currentUser.name || currentUser.username;
      }
      const apiBody = {
        'name': action.payload.name,
        'parent': action.payload.parent,
        'doc_type': action.payload.docType || 'dir',
        'alarm_device_types': action.payload.alarmDeviceTypes || [], 
        'alarm_devices': action.payload.alarmDevices || [],
        'created_by': createdBy,
      };
  
      const meta = {
        method: 'POST',
        url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages,
        onSuccess: CREATE_CATEGORY_SUCCESS,
        onError: CREATE_CATEGORY_ERROR,
        auth: store.getState().auth.token,
        body: apiBody,
        setStateFunc: action.payload.setStateFunc,
      };
  
      store.dispatch(showLoading());
      store.dispatch(apiRequest(apiBody, meta));
    }
  };
  
  // middleware to handle the success response:
  export const handleCreateCategorySuccess = ({ dispatch }) => (next) => (action) => {
    next(action);
    if (action.type === CREATE_CATEGORY_SUCCESS) {
  
    // Call the callback if provided
    if (action.meta && action.meta.setStateFunc) {
      action.meta.setStateFunc({
        ...action.payload,
        success: true
      });
    }
     // Hide loading indicator
    dispatch(hideLoading());
  }
};


  export const submitFile = (store) => (next) => (action) => {
    next(action);

     const state = store.getState();
      
      // Check if we have user data, if not, fetch it first
      const hasUserData = state.currentUser || state.auth?.user || state.user;
      
      if (!hasUserData && state.auth?.token) {
        
        // Dispatch action to get current user info
        store.dispatch({ type: GET_CURRENT_USER_INFO });
      
      }
    if (action.type === SUBMIT_FILE_REQUEST) {
      const formData = new FormData();
      formData.append('name', action.payload.name);
      
      // Handle parent ID - use Sara node for uncategorized files
      const parentId = action.payload.parent;
      const saraNodeId = store.getState().docCategoryReducer?.categoriesFiles?.saraNodeId;
      const catmoNodeId = store.getState().docCategoryReducer?.categoriesFiles?.catmoNodeId;
      
      if (parentId !== null && parentId !== undefined && parentId !== '') {
        formData.append('parent', parentId);
      } else if (saraNodeId) {
        // For uncategorized files, assign to Sara node
        formData.append('parent', saraNodeId);
      }
      
      formData.append('doc_type', action.payload.docType || 'media-file'); 
      
      if (action.payload.object_id) {
        formData.append('object_id', action.payload.object_id);
      }
     
      if (action.payload.mimeType) {
        formData.append('mime_content_type', action.payload.mimeType);
      } else if (action.payload.file && action.payload.file.type) {
        // If no explicit mimeType but file has a type, use that
        formData.append('mime_content_type', action.payload.file.type);
      }
      
      const currentUser = state.currentUser || state.auth?.user || state.user;
      
      if (currentUser && (currentUser.name || currentUser.username)) {
          const createdBy = currentUser.name || currentUser.username;
          formData.append('created_by', createdBy);
          // console.log('Adding created_by:', createdBy);
        } else {
          formData.append('created_by', 'System User');
        }
      
      if (action.payload.file) {
        formData.append('file', action.payload.file); 
      }

      //  Handle alarm device types
       if (action.payload.alarmDeviceTypes && action.payload.alarmDeviceTypes.length > 0) {
        // Convert array of types to numbers if needed
        const deviceTypes = action.payload.alarmDeviceTypes.map(type => 
          typeof type === 'string' ? Number(type) : type
        );
        deviceTypes.forEach(type => {
          formData.append('alarm_device_types', type); 
        });
      }
      
      // Handle alarm devices
      if (action.payload.alarmDevices && action.payload.alarmDevices.length > 0) {
        const deviceIds = action.payload.alarmDevices.map(id => 
          typeof id === 'string' ? Number(id) : id
        );
        deviceIds.forEach(id => {
          formData.append('alarm_devices', id); 
        });
      }
      // console.log(formData);
     

      const meta = {
        method: 'POST',
        url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages,
        onSuccess: CREATE_FILE_SUCCESS,
        onError: CREATE_FILE_ERROR,
        auth: store.getState().auth.token,
        body: formData,
        formData: true,
        setStateFunc: action.payload.setStateFunc,
        parentCategoryId: parentId, // Original parent selection
        isUncategorized: !parentId || parentId === saraNodeId || parentId === catmoNodeId, // Flag to indicate if this should be uncategorized
        saraNodeId: saraNodeId
      };

      store.dispatch(showLoading());
      store.dispatch(apiRequest(formData, meta));
    }
  };
  
// And the complementary success handle / parent category ID is stored in the meta object during the request
export const handleFileSuccess = ({ dispatch }) => (next) => (action) => {
  
  if (action.type === CREATE_FILE_SUCCESS) {
    

    // Check if this was intended to be an uncategorized file
    const isUncategorized = action.meta && action.meta.isUncategorized;
    
    if (isUncategorized) {
      // This is an uncategorized file - even though it was sent to Sara node, treat as uncategorized
      const uncategorizedFilePayload = {
        ...action.payload,
        parent: null,
        parentCategoryId: null,
        isFile: true 
      };
      
      // Create a completely new action with the modified payload
      const newAction = {
        type: CREATE_FILE_SUCCESS,
        payload: uncategorizedFilePayload,
        meta: action.meta
      };
      
      dispatch(hideLoading());
      
      if (typeof action.meta.setStateFunc === 'function') {
        action.meta.setStateFunc(uncategorizedFilePayload);
      }
      
      // Pass only the new action to the reducer, not the original
      next(newAction);
      return; // Don't process the original action
    }

    // check to see if a parentCategoryId is assigned before the dispatch (categorized files)
    if (!action.payload.parentCategoryId && action.meta && action.meta.parentCategoryId) {
      try {
        const enhancedPayload = {
          ...action.payload,
          parentCategoryId: action.meta.parentCategoryId,
          isFile: true 
        };
        
        // Create a completely new action with the enhanced payload
        const newAction = {
          type: CREATE_FILE_SUCCESS,
          payload: enhancedPayload,
          meta: action.meta
        };
        
        dispatch(hideLoading());
        
        if (typeof action.meta.setStateFunc === 'function') {
          action.meta.setStateFunc(enhancedPayload);
        }
        
        // Pass only the new action to the reducer, not the original
        next(newAction);
        return; // Don't process the original action
      } catch (error) {
        // Fall through to default handling on error
      }
    }
    
    // For any other cases, ensure we handle loading and callbacks but don't duplicate
    dispatch(hideLoading());
    if (action.meta && typeof action.meta.setStateFunc === 'function') {
      action.meta.setStateFunc(action.payload);
    }
    
    // Pass through the action (original action for categorized files)
    next(action);
    return;
  }
  
  // Default case - pass through unmodified for other action types
  next(action);
};

// File fetch middleware
export const fetchFileRequest = (store) => (next) => (action) => {
  next(action);
  
  if (action.type === FETCH_FILE_REQUEST) {
    const { fileId, callback } = action.payload;

    const baseUrl = apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages;
    const fileUrl = baseUrl.endsWith('/') ? `${baseUrl}${fileId}/` : `${baseUrl}/${fileId}/`;
    
    const meta = {
      method: 'GET',
      url: fileUrl,
      onSuccess: FETCH_FILE_SUCCESS,
      onError: CREATE_FILE_ERROR, 
      auth: store.getState().auth.token,
      fileId,
      callback: callback, 
    };
    
    store.dispatch(showLoading());
    store.dispatch(apiRequest(null, meta));
  }
};

// Handle fetch file success
export const handleFetchFileSuccess = ({ dispatch, getState }) => (next) => (action) => {
  next(action);

  if (action.type === FETCH_FILE_SUCCESS) {
    
    // Check if this is a Catmo file that needs a media API call
    const isCatmoFile = action.payload.catmo_id && !action.payload.file && action.payload.object_id;
    
    if (isCatmoFile) {
      
      // Get siteId from store state - must be present
      const state = getState();
      const siteId = state.auth?.siteId || state.currentUser?.siteId || state.site?.id;
      
      if (!siteId) {
        dispatch(hideLoading());
        
        if (action.meta && action.meta.callback) {
          action.meta.callback({
            ...action.payload,
            file: null,
            error: "No siteId available for media API call"
          });
        }
        return;
      }
      
      // Make API call to media endpoint to get the signed URL
      const mediaApiUrl = `/media/v2/media/${action.payload.object_id}?siteId=${siteId}`;
      
      fetch(mediaApiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(mediaResponse => {
        console.log("Media API response:", mediaResponse);
        
        const fileData = {
          id: action.payload.id,
          name: action.payload.name || "File",
          type: mediaResponse.mediaType || action.payload.mimetype || 'application/octet-stream',
          file: mediaResponse.file, 
          mime_content_type: action.payload.mime_content_type,
          mimeType: mediaResponse.mediaType || action.payload.mime_content_type,
          mimetype: mediaResponse.mediaType,
          object_id: action.payload.object_id,
          catmo_id: action.payload.catmo_id,
        };
        
        // console.log("Processed Catmo fileData being sent to callback:", fileData);
        
        dispatch(hideLoading());
        
        dispatch({
          type: 'SET_SELECTED_FILE',
          payload: fileData
        });
        
        if (action.meta && action.meta.callback) {
          action.meta.callback(fileData);
        }
      })
      .catch(error => {
        console.error("Error fetching media API:", error);
        dispatch(hideLoading());
        
        if (action.meta && action.meta.callback) {
          action.meta.callback({
            ...action.payload,
            file: null,
            error: "Failed to fetch media URL"
          });
        }
      });
      
      return; 
    }
    
    // For regular Sara files, process normally
    const fileData = {
      id: action.payload.id,
      name: action.payload.name || "File",
      type: action.payload.mediaType || action.payload.mimetype || 
            (action.payload.file?.endsWith('.pdf') ? 'application/pdf' : 'application/octet-stream'),
      file: action.payload.file || action.payload.url || action.payload.media_url || action.payload.download_url,
      mime_content_type: action.payload.mime_content_type,
      mimeType: action.payload.mimeType || action.payload.mime_content_type,
      mimetype: action.payload.mimetype,
      object_id: action.payload.object_id,
      catmo_id: action.payload.catmo_id, // Include catmo_id for identification
    };
    
    // console.log("Processed fileData being sent to callback:", fileData);
    
    dispatch(hideLoading());
    
    dispatch({
      type: 'SET_SELECTED_FILE',
      payload: fileData
    });
    
    
    if (action.meta && action.meta.callback) {
      action.meta.callback(fileData);
    }
  } 
};

// Edit Category Middleware
export const submitEditCategory = (store) => (next) => (action) => {
  next(action);
  if (action.type === SUBMIT_EDIT_CATEGORY) {
    const { id, name, parent, docType, alarmDeviceTypes, alarmDevices, setStateFunc } = action.payload;
    
    const apiBody = {
      'name': name,
      'parent': parent,
      'doc_type': docType || 'dir',
      'alarm_device_types': alarmDeviceTypes || [], 
      'alarm_devices': alarmDevices || [],
      'update_children_devices': true
    };
    // console.log("action hit",action.payload)
    const meta = {
      method: 'PATCH',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages + action.payload.id + '/',
      onSuccess: EDIT_CATEGORY_SUCCESS,
      onError: EDIT_CATEGORY_ERROR,
      auth: store.getState().auth.token,
      body: apiBody,
      setStateFunc: setStateFunc,
    };

    store.dispatch(showLoading());
    store.dispatch(apiRequest(apiBody, meta));
  }
};

export const editCategorySuccess = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === EDIT_CATEGORY_SUCCESS) {
    console.log("Category updated successfully:", action.payload);
    dispatch(hideLoading());
    
    
    if (action.meta && action.meta.setStateFunc) {
      action.meta.setStateFunc({
        ...action.payload,
        success: true
      });
    }
  }
};

export const editCategoryError = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === EDIT_CATEGORY_ERROR) {
    console.error("Error updating category:", action.payload);
    dispatch(hideLoading());
  }
};

// Delete Category Middleware
export const deleteCategory = (store) => (next) => (action) => {
  next(action);
  if (action.type === DELETE_CATEGORY_REQUEST) {
    const categoryId = action.payload.id;
    const setStateFunc = action.payload.setStateFunc;
    
    console.log("Deleting category with ID:", categoryId);

    const meta = {
      method: 'DELETE',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages + action.payload.id + '/',
      onSuccess: DELETE_CATEGORY_SUCCESS,
      onError: DELETE_CATEGORY_ERROR,
      auth: store.getState().auth.token,
      categoryId: categoryId, 
      setStateFunc: action.payload.setStateFunc,
    };

    store.dispatch(showLoading());
    store.dispatch(apiRequest(null, meta));
  }
};

// Middleware for handling successful category deletion
export const deleteCategorySuccess = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === DELETE_CATEGORY_SUCCESS) {
    console.log("Category deleted successfully:", action.meta.categoryId);
    // dispatch(hideLoading());

    const enhancedAction = {
      type: DELETE_CATEGORY_SUCCESS,
      payload: {
        categoryId: action.meta.categoryId
      },
      meta: action.meta
    };
    
    dispatch(enhancedAction);
    dispatch(hideLoading());
    
    // Notify the component about success
    if (action.meta && action.meta.setStateFunc) {
      action.meta.setStateFunc({
        success: true,
        message: "Category deleted successfully",
        categoryId: action.meta.categoryId
      });
    }
    return; 
  }
  
};


export const submitEditFile = (store) => (next) => (action) => {
  next(action);
  if (action.type === SUBMIT_EDIT_FILE) {
    const { 
      id, 
      name, 
      parent, 
      docType, 
      alarmDeviceTypes, 
      alarmDevices, 
      file,
      object_id, 
      mimeType,
      setStateFunc 
    } = action.payload;

    // console.log("EDIT FILE REQUEST - Full payload:", action.payload);
    // console.log("EDIT FILE REQUEST - Parent ID:", parent);
    
    // Use FormData for file uploads
    const formData = new FormData();
    
    // Handle parent ID - preserve Catmo lineage for Catmo files
    const saraNodeId = store.getState().docCategoryReducer?.categoriesFiles?.saraNodeId;
    const catmoNodeId = store.getState().docCategoryReducer?.categoriesFiles?.catmoNodeId;
    
    // Check if this is a Catmo file (has catmo_id or hasCatmoLineage flag)
    const isCatmoFile = action.payload.catmo_id || action.payload.hasCatmoLineage;
    
    // For Catmo files, only allow device association changes, preserve original name and other properties
    if (!isCatmoFile) {
      formData.append('name', name);
    }
    
    if (parent !== null && parent !== undefined && parent !== '') {
      formData.append('parent', Number(parent));
    } else if (isCatmoFile && catmoNodeId) {
      // For uncategorized Catmo files, assign to Catmo node to preserve lineage
      formData.append('parent', catmoNodeId);
    } else if (saraNodeId) {
      // For uncategorized Sara files, assign to Sara node
      formData.append('parent', saraNodeId);
    }
    
    // For non-Catmo files, handle doc_type, object_id, mime_content_type, and file uploads
    if (!isCatmoFile) {
      formData.append('doc_type', docType || 'media-file');

      if (object_id && 
        object_id !== 'null' && 
        object_id !== '' && 
        object_id !== null && 
        object_id !== undefined) {
        formData.append('object_id', object_id);
      }

      if (mimeType) {
        formData.append('mime_content_type', mimeType);
      } else if (file && file.type) {
        // If no explicit mimeType but file has a type, use that
        formData.append('mime_content_type', file.type);
      }

      if (docType && typeof docType === 'string') {
        formData.append('doc_type', docType);
      } else {
        // Fallback if no valid docType
        formData.append('doc_type', 'media-file');
      }
      
      // Only append file for non-Catmo files
      if (file) {
        formData.append('file', file);
      }
    }
    
    if (alarmDeviceTypes && alarmDeviceTypes.length > 0) {
      alarmDeviceTypes.forEach(typeId => {
        // Ensure each value is a number, not a string
        formData.append('alarm_device_types', typeof typeId === 'string' ? Number(typeId) : typeId);
      });
    }

     if (alarmDevices && alarmDevices.length > 0) {
      alarmDevices.forEach(deviceId => {
        // Ensure each value is a number, not a string
        formData.append('alarm_devices', typeof deviceId === 'string' ? Number(deviceId) : deviceId);
      });
    }

    
    const meta = {
      method: 'PATCH',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages + action.payload.id + '/',
      onSuccess: EDIT_FILE_SUCCESS,
      onError: EDIT_FILE_ERROR,
      auth: store.getState().auth.token,
      body: formData,
      formData: true, 
      setStateFunc: setStateFunc,
      parentCategoryId: parent,
      isUncategorized: !parent, // Flag to indicate if this should be uncategorized (only when no parent selected)
      isCatmoFile: isCatmoFile, // Flag to identify Catmo files
      saraNodeId: saraNodeId,
      catmoNodeId: catmoNodeId
    };

    store.dispatch(showLoading());
    store.dispatch(apiRequest(formData, meta));
  }
};

export const editFileSuccess = ({ dispatch }) => (next) => (action) => {
  
  if (action.type === EDIT_FILE_SUCCESS) {
    // console.log("File updated successfully:", action.payload);
    
    const isUncategorized = action.meta && action.meta.isUncategorized;
    
    // Handle uncategorized files (no parent selected by user)
    if (isUncategorized) {
      const isCatmoFile = action.meta && action.meta.isCatmoFile;
      const catmoNodeId = action.meta && action.meta.catmoNodeId;
      
      const uncategorizedPayload = {
        ...action.payload,
        parent: isCatmoFile && catmoNodeId ? catmoNodeId : null, // Preserve Catmo lineage for Catmo files
        parentCategoryId: null, 
        isFile: true
      };
      
      // Create a completely new action with the modified payload
      const newAction = {
        type: EDIT_FILE_SUCCESS,
        payload: uncategorizedPayload,
        meta: action.meta
      };
      
      dispatch(hideLoading());
      
      if (action.meta && action.meta.setStateFunc) {
        action.meta.setStateFunc(uncategorizedPayload);
      }
      
      // Pass only the new action to the reducer, not the original
      next(newAction);
      return; // Don't process the original action
    }

    // Handle categorized files
    if (action.meta && action.meta.parentCategoryId) {
      const enhancedPayload = {
        ...action.payload,
        parent: action.meta.parentCategoryId, 
        parentCategoryId: action.meta.parentCategoryId, // Set parentCategoryId for reducer logic
        isFile: true
      };
      
      // console.log("Enhanced payload with correct parent:", enhancedPayload);
      
      // Create a completely new action with the enhanced payload
      const newAction = {
        type: EDIT_FILE_SUCCESS,
        payload: enhancedPayload,
        meta: action.meta
      };
      
      dispatch(hideLoading());
      
      if (action.meta.setStateFunc) {
        action.meta.setStateFunc(enhancedPayload);
      }
      
      // Pass only the new action to the reducer, not the original
      next(newAction);
      return; // Don't process the original action
    }
    
    // For any other cases, ensure we handle loading and callbacks but don't duplicate
    dispatch(hideLoading());
    if (action.meta && typeof action.meta.setStateFunc === 'function') {
      action.meta.setStateFunc(action.payload);
    }
    
    // Pass through the action for EDIT_FILE_SUCCESS
    next(action);
    return;
  }
  
  // For non-EDIT_FILE_SUCCESS actions, just pass through
  next(action);
};
		

export const editFileError = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === EDIT_FILE_ERROR) {
    console.error("Error updating file:", action.payload);
    dispatch(hideLoading());
    
    if (action.meta && action.meta.setStateFunc) {
      action.meta.setStateFunc({
        success: false,
        message: "Failed to update file",
        error: action.payload
      });
    }
  }
};

// Middleware for deleting a file
export const deleteFile = (store) => (next) => (action) => {
  next(action);
  if (action.type === DELETE_FILE_REQUEST) {
    const fileId = action.payload.id;
    const parentId = action.payload.parentId;
    const setStateFunc = action.payload.setStateFunc;
    
    console.log("Deleting file with ID:", fileId, "Parent ID:", parentId);

    const meta = {
      method: 'DELETE',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages + fileId + '/',
      onSuccess: DELETE_FILE_SUCCESS,
      onError: DELETE_FILE_ERROR,
      auth: store.getState().auth.token,
      fileId: fileId,
      parentId: parentId,
      setStateFunc: setStateFunc,
    };

    store.dispatch(showLoading());
    store.dispatch(apiRequest(null, meta));
  }
};

// Middleware for handling successful file deletion
export const deleteFileSuccess = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === DELETE_FILE_SUCCESS) {
    console.log("File deleted successfully - File ID:", action.meta.fileId, "Parent ID:", action.meta.parentId);

    const enhancedAction = {
      type: DELETE_FILE_SUCCESS,
      payload: {
        fileId: action.meta.fileId,
        parentId: action.meta.parentId
      },
      meta: action.meta
    };
    
    dispatch(enhancedAction);
    dispatch(hideLoading());
    
    // Notify the component about success
    if (action.meta && action.meta.setStateFunc) {
      action.meta.setStateFunc({
        success: true,
        message: "File deleted successfully",
        fileId: action.meta.fileId,
        parentId: action.meta.parentId
      });
    }
    return;
  }
};


export const deleteFileError = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === DELETE_FILE_ERROR) {
    console.error("Error deleting file:", action.payload);
    dispatch(hideLoading());
    
    // Notify the component about error
    if (action.meta && action.meta.setStateFunc) {
      action.meta.setStateFunc({
        success: false,
        message: "Failed to delete file",
        error: action.payload
      });
    }
  }
};


//   export const addUncategorizedFile = (store) => (next) => (action) => {
//   next(action);
  
//   // Handle the initial action to add uncategorized file
//   if (action.type === ADD_UNCATEGORIZED_FILE) {
//     // Prepare proper FormData for the file upload
//     const formData = new FormData();
    
//     // Add file metadata
//     formData.append('name', action.payload.name);
//     formData.append('doc_type', action.payload.docType || 'sara-file');
    
//     // Only add parent if it's specified
//     if (action.payload.categoryId) {
//       formData.append('parent', action.payload.categoryId);
//     }
    
//     // Add the actual file if present
//     if (action.payload.file) {
//       formData.append('file', action.payload.file);
//     }
    
//     // Add any other required fields from your payload
//     if (action.payload.url) {
//       formData.append('url', action.payload.url);
//     }
    
//     console.log("Uploading uncategorized file:", {
//       name: action.payload.name,
//       hasCategory: !!action.payload.categoryId,
//       categoryId: action.payload.categoryId || 'none'
//     });

//     const meta = {
//       method: 'POST',
//       url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages,
//       onSuccess: ADD_UNCATEGORIZED_FILE_SUCCESS, 
//       onError: ADD_UNCATEGORIZED_FILE_ERROR,
//       auth: store.getState().auth.token,
//       body: formData,
//       formData: true, 
//       categoryId: action.payload.categoryId // Store original categoryId in meta
//     };

//     store.dispatch(showLoading());
//     store.dispatch(updateApiSpinner({ uncategorizedFileAdding: true }));
//     store.dispatch(apiRequest(formData, meta));
//   }
  
// };

// export const handleUncategorizedFileSuccess = ({ dispatch }) => (next) => (action) => {
//   if (action.type === ADD_UNCATEGORIZED_FILE_SUCCESS) {
//     dispatch(hideLoading());
//     dispatch(updateApiSpinner({ uncategorizedFileAdding: false }));
    
//     // Log the response for debugging
//     console.log("Uncategorized file API response:", action.payload);
    
//     // Create a properly formatted file object
//     const fileObject = {
//       id: action.payload.id,
//       name: action.payload.name,
//       doc_type: action.payload.doc_type || 'sara-file',
//       file: action.payload.file || action.payload.url,
//       url: action.payload.url || action.payload.file,
//       isFile: true,
//       created: action.payload.created,
//       modified: action.payload.modified,
//       created_by: action.payload.created_by
//     };
    
//     // If the original request had a categoryId, assign to that category
//     if (action.meta && action.meta.categoryId) {
//       console.log("File will be assigned to category:", action.meta.categoryId);
      
//       dispatch({
//         type: CREATE_FILE_SUCCESS,
//         payload: {
//           ...fileObject,
//           parent: action.meta.categoryId,
//           parentCategoryId: action.meta.categoryId
//         }
//       });
//     } else {
//       // Otherwise, explicitly mark as uncategorized and add to uncategorized files
//       console.log("File will be added to uncategorized files");
      
//       dispatch({
//         type: ADD_UNCATEGORIZED_FILE_SUCCESS, 
//         payload: {
//           ...fileObject,
//           parent: null,
//           parentCategoryId: null
//         }
//       });
//     }
    
//     return; 
//   }
  
//   next(action);
// };

// export const assignFileToCategory = (store) => (next) => (action) => {
//   next(action);
  
//   if (action.type === ASSIGN_FILE_TO_CATEGORY) {
//     const { fileId, categoryId } = action.payload;

//     const formData = new FormData();
//     formData.append('parent', categoryId)
    
//     const meta = {
//       method: 'POST', 
//       url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].documentandimages + fileId + '/',
//       onSuccess: ASSIGN_FILE_TO_CATEGORY_SUCCESS,
//       onError: ASSIGN_FILE_TO_CATEGORY_ERROR,
//       auth: store.getState().auth.token,
//       body: formData,
//       formData: true,
//       fileId: fileId,     
//       categoryId: categoryId 
//     };
    
//     store.dispatch(showLoading());
//     store.dispatch(updateApiSpinner({ assigningFile: true }));
//     store.dispatch(apiRequest(null, meta));
//   }
  
//   if (action.type === ASSIGN_FILE_TO_CATEGORY_SUCCESS) {
//     store.dispatch(hideLoading());
//     store.dispatch(updateApiSpinner({ assigningFile: false }));
    
//     // Convert the response to the format expected by your reducer
//     const fileData = {
//       ...action.payload,
//       parentCategoryId: action.payload.categoryId || action.payload.parent
//     };
    
//     // Update Redux state to move file from uncategorized to the category
//     store.dispatch(handleFileSuccess(fileData));
    
//   }
  
//   if (action.type === ASSIGN_FILE_TO_CATEGORY_ERROR) {
//     store.dispatch(hideLoading());
//     store.dispatch(updateApiSpinner({ assigningFile: false }));
    
//   }
// };

// export const handleAssignFileToCategorySuccess = ({ dispatch }) => (next) => (action) => {
//   if (action.type === ASSIGN_FILE_TO_CATEGORY_SUCCESS) {
//     dispatch(hideLoading());
//     dispatch(updateApiSpinner({ assigningFile: false }));
    
//     console.log("File assignment success response:", action.payload);
//     console.log("Meta data:", action.meta);
    
//     // Prepare the file object with the correct parent
//     const updatedFile = {
//       ...action.payload,
//       id: action.meta.fileId, // Ensure ID is present
//       parent: action.meta.categoryId,
//       parentCategoryId: action.meta.categoryId,
//       isFile: true
//     };
    
//     console.log("Dispatching updated file with new parent:", updatedFile);
    
//     // Dispatch the appropriate action to update Redux state
//     dispatch({
//       type: ASSIGN_FILE_TO_CATEGORY_SUCCESS,
//       payload: updatedFile
//     });
    
    
//     return; 
//   }
  
//   next(action);
// };

  export const docAndImagesMdl = [
    loadDocCategories,
    // addUncategorizedFile,
    submitCreateCategory,
    // handleUncategorizedFileSuccess,
    // assignFileToCategory,
    // handleAssignFileToCategorySuccess,
    handleCreateCategorySuccess,
    setDocTree,
    submitFile,
    handleFileSuccess,
    fetchFileRequest,
    handleFetchFileSuccess,
    submitEditCategory,
    editCategorySuccess,
    deleteCategory,
    deleteCategorySuccess,
    submitEditFile,
    editFileSuccess,
    editFileError,
    deleteFile,
    deleteFileSuccess,
    deleteFileError
  ]